import { Action } from "@ngrx/store";
import { NotificationCounters, NotificationsCount } from "./notifications.model";

export enum NotificationsActionTypes {
  SetNotificationsCount = "[Notifications] SetNotificationsCount",
  SetNotificationsCountSuccess = "[Notifications] SetNotificationsCountSuccess",
  SetNotificationsCountFault = "[Notifications] SetNotificationsCountFault",
  MarkAllReadNotifications = "[Notifications] MarkAllReadNotifications",
  MarkAllReadNotificationsSuccess = "[Notifications] MarkAllReadNotificationsSuccess",
  MarkAllReadNotificationsFault = "[Notifications] MarkAllReadNotificationsFault",
  // SAN-1428 — notification centre counters (GET notifications/counters).
  FetchNotificationCounters = "[Notifications] FetchNotificationCounters",
  FetchNotificationCountersSuccess = "[Notifications] FetchNotificationCountersSuccess",
  FetchNotificationCountersFault = "[Notifications] FetchNotificationCountersFault",
  // SAN-1433 — optimistic: a pending request was accepted / declined.
  ConnectionRequestHandled = "[Notifications] ConnectionRequestHandled"
}

export class SetNotificationsCount implements Action {
  readonly type = NotificationsActionTypes.SetNotificationsCount;
}

export class SetNotificationsCountSuccess implements Action {
  readonly type = NotificationsActionTypes.SetNotificationsCountSuccess;

  constructor(public payload: NotificationsCount) { }
}

export class SetNotificationsCountFault implements Action {
  readonly type = NotificationsActionTypes.SetNotificationsCountFault;
  constructor(public payload: string) { }
}

export class MarkAllReadNotifications implements Action {
  readonly type = NotificationsActionTypes.MarkAllReadNotifications;
}

export class MarkAllReadNotificationsSuccess implements Action {
  readonly type = NotificationsActionTypes.MarkAllReadNotificationsSuccess;

  constructor(public payload: NotificationsCount) { }
}

export class MarkAllReadNotificationsFault implements Action {
  readonly type = NotificationsActionTypes.MarkAllReadNotificationsFault;
  constructor(public payload: string) { }
}

export class FetchNotificationCounters implements Action {
  readonly type = NotificationsActionTypes.FetchNotificationCounters;
}

export class FetchNotificationCountersSuccess implements Action {
  readonly type = NotificationsActionTypes.FetchNotificationCountersSuccess;

  constructor(public payload: NotificationCounters) { }
}

export class FetchNotificationCountersFault implements Action {
  readonly type = NotificationsActionTypes.FetchNotificationCountersFault;
  constructor(public payload: string) { }
}

// SAN-1433 (W-02 annotation 1) — drop the Connections badge, the bell and the
// Received count by 1 at once; the counters refetch then reconciles them.
export class ConnectionRequestHandled implements Action {
  readonly type = NotificationsActionTypes.ConnectionRequestHandled;
}

export type NotificationsActions =
  | SetNotificationsCount
  | SetNotificationsCountSuccess
  | SetNotificationsCountFault
  | MarkAllReadNotifications
  | MarkAllReadNotificationsSuccess
  | MarkAllReadNotificationsFault
  | FetchNotificationCounters
  | FetchNotificationCountersSuccess
  | FetchNotificationCountersFault
  | ConnectionRequestHandled;
